class EventTracker {
  constructor(provider) {
    this.provider = provider;
    this.track = this.track.bind(this);
  }

  track(eventName, action, data = {}) {
    this.provider(eventName, action, data);
    return null;
  }
}
export default EventTracker;



// WEBPACK FOOTER //
// ./src/services/EventTracker.js